module.exports = __webpack_public_path__ + "static/media/prev-arrow.3ff3d228.svg";